module.exports = __webpack_public_path__ + "img/drh5_share_jp.faa2cb59.png";